<template>
  <div id="live">
    <div class="bg"></div>
    <div class="live-box">
      <div class="fullScreenBox">
        <div class="video-header">
          <div class="header-left">
            <div class="icon"></div>
            <UiLabel class="title" shadow-color="#540001">{{ liveInfo.title }}</UiLabel>
            <div class="type" v-if="liveInfo.is_online">直播</div>
            <div class="audience" v-if="liveInfo.is_online">
              <i></i>
              <span>{{ liveInfo.audience }}</span>
            </div>
          </div>
          <!-- <div class="outerline">
            <a href="https://www.taptap.cn/" >这是一个外部链接</a>
          </div> -->
        </div>
        <div class="video-container">
          <Video
            ref="videoPlayer"
            :liveInfo="liveInfo"
            :feedBackStatus="feedBackStatus"
          >
          </Video>
          <div class="errorPrompt" v-if="showPrompt">
            <div class="prompt">{{ errorPrompt }}</div>
          </div>
        </div>

        <!-- 隐藏的战队信息 -->
        <div class="switch-source">
          <Room
            :list="liveRoomList"
            :data="cheerForList"
            @updatelivelink="handleLiveEvent"
            @bettingLimit="handleBettingLimit"
          >
          </Room>
        </div>
      </div>
    </div>

    <!-- 侧边栏 -->
    <div class="side-box">
      <div class="side-inner">
        <div class="title">
          <div
            class="tab title-schedule"
            :class="{ active: activeTab === 'schedule' }"
            @click="changeTab('schedule')"
          >
            <UiLabel>赛程</UiLabel>
          </div>
          <div
            class="tab title-rank"
            :class="{ active: activeTab === 'rank' }"
            @click="changeTab('rank')"
          >
            <UiLabel>排行</UiLabel>
          </div>
        </div>
        <div class="side-content">
          <div class="inner-box" ref="sideBox"  :class="{ clearActive: activeTab === 'rank' }">
            <Schedule
              v-if="activeTab === 'schedule'"
              :openScore="openScore"
              :openTeams="openTeams"
              :arrangeList="arrangeList"
              :handleAnchor="handleAnchor"
            >
            </Schedule>
            <Rank
              :rankType="rankType"
              v-if="activeTab === 'rank'"
            >
            </Rank>
          </div>
        </div>
      </div>
    </div>
    <Score ref="scoreModal"></Score>
    <Teams ref="teamsModal"></Teams>
  </div>
</template>


<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount, useTemplateRef } from 'vue'
import * as api from '@/service/index'
import { useAppStore } from '@/store'
import Video from '@/views/live/video.vue'
import Room from '@/views/live/room'
import Schedule from '@/views/live/side/schedule'
import Rank from '@/views/live/side/rank'
import Score from '@/views/schedule/score'
import Teams from '@/views/schedule/teams'
// import UiTipDot from '@/components/ui-tip-dot.vue'
import { usePrompt } from '@/composables/usePrompt'
import UiLabel from '@/components/ui-label.vue'

const appStore = useAppStore()

const videoPlayer = useTemplateRef('videoPlayer')
const sideBox = useTemplateRef('sideBox')
// 页面内 showPrompt 已被视频报错提示占用, 借用 alias 避免冲突
const { showPrompt: toast } = usePrompt()
const scoreModal = useTemplateRef('scoreModal')
const teamsModal = useTemplateRef('teamsModal')

function openScore(code, title) {
  scoreModal.value.initMatchDetail(code, title)
}
function openTeams(teams) {
  teamsModal.value.initTeams(teams)
}

const errorPrompt = ref('')
const networkStatus = ref('online')
const showPrompt = ref(false)

const type = ref(0)
const is_online = ref(1)

const dateZh = ref(['日', '一', '二', '三', '四', '五', '六'])
const seasonList = ref([])
const subSeasonID = ref('')
const arrangeList = ref([])
const currentTime = ref('')
const subScheduleTeams = ref([])
// liveLink: 'https://xcc.xindong.com/api/v2.1/lives/1-1199535425545?game_id=58881',
// socket :null
// 默认第一个直播源
// liveLink :'',
const liveRoomList = ref([])
const cheerForList = ref([])
const presentList = ref([]) //  商品列表
const activeTab = ref('schedule')
const rankType = ref('')

// 原 fetchActivityList 中赋值的 listData（原选项式中未在 data 声明）

const liveInfo = computed(() => appStore.liveInfo)
const token = computed(() => appStore.token)
const seasonInfo = computed(() => appStore.seasonInfo)

function getArrangeSeasons() {
  // console.log('getArrangeSeasons')
  if(!token.value) return;
  api.reqArrangeSeasons({ token: token.value }).then((response) => {
    if (response.status === 200) {
      // 所以赛季信息
      seasonList.value = response.data
      // 获取当前服务器时间
      api.reqcurrentTime().then((response) => {
        if (response.status === 200) {
          currentTime.value = new Date(response.data).getTime()
        } else {
          currentTime.value = new Date()
        }
        switchSeason(subSeasonID.value)
      })
    } else {
      toast(response.data)
    }
  })
}
// handleSwitch(hls) {
//   this.showSelect = false;
//   // this.$refs.videoPlayer.updateHls(hls);
// },
function feedBackStatus(typeVal, isOnline) {
  type.value = typeVal
  is_online.value = isOnline
  if (networkStatus.value === 'online') {
    errorPrompt.value = ''
    showPrompt.value = false

    //type 0: wifi  1: 流量  2: videojs错误 3: 兼容性，安卓版本太低
    if (!is_online.value || type.value === 2) {
      errorPrompt.value = '主播已下线'
      showPrompt.value = true
    } else if (is_online.value && type.value === 1) {
      errorPrompt.value = '当前正在使用非WiFi网络，继续播放将产生流量费用'
      showPrompt.value = true
    }
  } else {
    errorPrompt.value = '当前网络不可用'
    showPrompt.value = true
  }
}
function switchSeason(id) {
  // 侧边栏 赛程简介
  let subSeason = seasonList.value.find((season) => season.id === id)
  if (subSeason) {
    // 当前赛季ID
    subSeasonID.value = subSeason.id
    // 当前赛季安排
    let list = []
    subSeason.scheduleList.forEach((schedule) => {
      let category = {}
      // 格式化每天的安排
      let dateObj = new Date(schedule.startAt)
      category.day = formatDay(dateObj)
      category.week = `周${dateZh.value[dateObj.getDay()]}`
      category.time = formatTime(dateObj)
      category.title = schedule.name
      category.teams = schedule.teamList || []
      if (currentTime.value < new Date(schedule.startAt)) {
        category.status = 1
      } else if (
        currentTime.value >= new Date(schedule.startAt) &&
        currentTime.value <= new Date(schedule.endAt)
      ) {
        category.status = 2
      } else {
        category.status = 3
      }
      category.scheduleCode = schedule.scheduleCode

      // 添加到对应那天的赛程安排中
      list.push(category)
    })

    arrangeList.value = list
  }
}
function formatDay(dateObj) {
  let month = dateObj.getMonth() + 1
  month = month < 10 ? '0' + month : month
  let day = dateObj.getDate()
  day = day < 10 ? '0' + day : day

  return `${month}月${day}日`
}
function formatTime(dateObj) {
  let hour = dateObj.getHours()
  hour = hour < 10 ? '0' + hour : hour
  let min = dateObj.getMinutes()
  min = min < 10 ? '0' + min : min

  return `${hour}:${min}`
}
function handleAnchor(offsetTop) {
  sideBox.value.scrollTop = offsetTop
}


async function initQuiz() {
  // 获取所有赛程
  if(!token.value) return;
  let response = await api.reqScheduleList({
    seasonId: subSeasonID.value,
    token: token.value
  })
  if (response.status === 200) {
    if (response.data && response.data.length !== 0) {
      let defaultScheduleID = response.data.find(
        (item) => item.isPresent
      ).scheduleCode
      getSubScheduleTeams(defaultScheduleID)
    }
  }
}
async function getSubScheduleTeams(schedule_code) {
  if(!token.value) return;
  let response = await api.reqScheduleTeams({
    scheduleCode: schedule_code,
    seasonId: subSeasonID.value,
    token: token.value,
    questionId: 0
  })
  if (response.status === 200) {
    subScheduleTeams.value = response.data
  }
}
async function getConfig() {
  let response = await api.reqConfig()
  if (response.status === 200) {
    // console.log('response', response.data.gift_list)
    // console.log('123',response)
    // 获取赠送礼物列表
    presentList.value = response.data.gift_list
    liveRoomList.value = response.data.roomLive
    // console.log(' this.presentList', this.presentList)
    // 首次获取第一个直播源进行播放
    getLiveInfo(liveRoomList.value[0]?.value)
  }
}

async function getLiveInfo(liveLink) {
  // console.log('liveLink', liveLink)
  try {
    const res = await api.getVideo(liveLink)
    // console.log('123');
    if (res.status === 200) {
      let data = res.data
      data.ld = ''
      data.hd = ''
      data.fhd = ''
      data.type = 'application/x-mpegURL'
      data.linesList = []
      let sources = data.sources
      if (sources && sources.length >= 1) {
        // 获取线路
        let linesList = []
        sources.forEach((item) => {
          let obj2 = {}
          obj2.name = item.name
          if (item.hls) {
            Object.keys(item.hls).forEach((key) => {
              let source = item.hls[key]
              if (source) {
                obj2.id = source
                return
              }
            })

            if (obj2.name && obj2.id) {
              linesList.push(obj2)
            }
          }
        })
        data.linesList = linesList

        if (linesList.length !== 0) {
          data.hd = linesList[0]['id']
        }
      }
      // 将直播间信息存储到全局 store，再次返回 live 路由时可直接复用
      appStore.liveInfo = data
      feedBackStatus(0, data.hd ? true : false)
    }
  } catch (err) {
    console.log(err)
  }
}
function handleLiveEvent(value) {
  getLiveInfo(value)
}
function changeTab(tab) {
  activeTab.value = tab
}
function handleBettingLimit(){
   toast('竞猜币已达上限,无法继续竞猜')
}

watch(
  seasonInfo,
  (newVal) => {
    if (newVal && newVal.id) {
      subSeasonID.value = newVal.id
      // 先请求赛季列表seasonList, 包含所有赛季，以及每个赛季设置的比赛阶段
      getArrangeSeasons()
      // 获取当前赛季的参赛队伍
      initQuiz()
    }
  },
  {
    immediate: true,
    deep: true
  }
)

// created
getConfig()

onMounted(() => {
  window.addEventListener('offline', () => {
    networkStatus.value = 'offline'

    feedBackStatus()
  })
  window.addEventListener('online', () => {
    networkStatus.value = 'online'

    feedBackStatus(0, true)
  })
})

onBeforeUnmount(() => {
  videoPlayer.value && videoPlayer.value.pause()
  // console.log('beforeUnmount');
})

</script>

<style lang="scss" scoped>
@import "./index";
</style>
